<template>
    <div class="dialog" :class="[isShowContent ? 'box-in' : 'box-out']" :style="boxShowStyle" @click.stop="cancel">
        <div
            v-if="themeColor != '' && isShowBox"
            class="main"
            :class="[isShowContent ? 'dialog-in' : 'dialog-out']"
            :style="dialogStyle"
            @click.stop
        >
            <div class="head" :style="themeBgColor">
                <div class="left">{{ title }}</div>
                <div class="right" @click.stop.prevent="cancel">×</div>
            </div>
            <div class="center" ref="center">
                <div class="center-content">
                    <slot></slot>
                </div>
            </div>
            <slot name="footer">
                <div class="footer">
                    <button
                        class="item cancel"
                        :style="cancelHoverStyle"
                        @mouseover="toggleCancelState(true)"
                        @mouseout="toggleCancelState(false)"
                        @click.stop.prevent="cancel"
                        v-if="isShowButton[0]"
                    >
                        取 消
                    </button>
                    <button class="item confirm" :style="themeBgColor" @click.stop="confirm" v-if="isShowButton[1]">
                        <div>确 认</div>
                        <div class="mask"></div>
                    </button>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "NativeDialog",
    data() {
        return {
            isCancelHover: false,
            isShowBox: false,
            isShowContent: false,
        };
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        themeColor: {
            type: String,
            default: "28, 176, 100",
        },
        isShowButton: {
            type: Array,
            default() {
                return [true, true];
            },
        },
        width: {
            type: Number,
            default: 500,
        },
        cancelHandler: {
            type: Function,
            default() {
                return function() {
                    this.close();
                };
            },
        },
        confirmHandler: {
            type: Function,
            default() {
                return function() {};
            },
        },
        top: {
            type: Number,
            default: 30,
        },
    },
    computed: {
        themeRgb() {
            return this.themeColor.split(",").map((item) => item.trim() * 1);
        },
        themeBgColor() {
            return {
                backgroundColor: `rgb(${this.themeColor})`,
            };
        },
        dialogStyle() {
            return {
                top: `${this.top}%`,
                width: `${this.width}px`,
            };
        },
        cancelHoverStyle() {
            if (!this.isCancelHover) {
                return {};
            }
            let { themeColor } = this;
            return {
                color: `rgb(${themeColor})`,
                backgroundColor: `rgba(${themeColor}, .1)`,
                border: `1px solid rgba(${themeColor}, .3)`,
            };
        },
        boxShowStyle() {
            return {
                display: this.isShowBox ? "block" : "none",
            };
        },
    },
    methods: {
        open() {
            this.isShowBox = true;
            this.isShowContent = true;
        },
        close(e) {
            this.isShowContent = false;
            setTimeout(() => {
                this.isShowBox = false;
                this.isCancelHover = false;
            }, 300);
        },
        confirm() {
            this.confirmHandler();
        },
        cancel() {
            this.close();
            setTimeout(() => this.cancelHandler(), 100);
        },
        toggleCancelState(state) {
            this.isCancelHover = state;
        },
    },
};
</script>

<style scoped>
@keyframes boxIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@keyframes boxOut {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@keyframes dialogIn {
    0% {
        transform: translate(-50%, -50%) scale(0.9);
    }
    100% {
        transform: translate(-50%, -50%) scale(1);
    }
}
@keyframes dialogOut {
    0% {
        transform: translate(-50%, -50%) scale(1);
    }
    100% {
        transform: translate(-50%, -50%) scale(0.9);
    }
}
.dialog-in {
    animation: dialogIn 0.3s ease 0s 1 alternate both running;
}
.dialog-out {
    animation: dialogOut 0.3s ease 0s 1 alternate both running;
}
.box-in {
    animation: boxIn 0.3s ease 0s 1 alternate both running;
}
.box-out {
    animation: boxOut 0.3s ease 0s 1 alternate both running;
}
</style>

<style scoped lang="scss">
.dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9;
    transition: all 0.3s;
    cursor: default;
    user-select: none;
    .main {
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 99;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        .head {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 20px;
            font-size: 16px;
            color: #fff;
            .right {
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 22px;
                cursor: pointer;
            }
        }
        .center {
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            /* margin: 20px 0; */
            min-height: 100px;
            padding: 15px 30px 20px;
            text-align: center;
            .center-content {
                width: 100%;
            }
        }
        .footer {
            display: flex;
            justify-content: center;
            padding-bottom: 20px;
            .item {
                width: 80px;
                height: 40px;
                margin-right: 15px;
                font-size: 14px;
                border: none;
                border-radius: 5px;
                background-color: #fff;
                cursor: pointer;
                transition: all 0.3s;
            }
            .item:last-child {
                margin-right: 0;
            }
            .confirm {
                position: relative;
                color: #fff;
            }
            .confirm:hover .mask {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                transition: all 0.3s;
                background-color: rgba(255, 255, 255, 0.2);
            }
            .cancel {
                color: #555;
                border: 1px solid #ccc;
            }
        }
    }
}
</style>
